const doc = [({"da":({"js":({"admin":({"steps":({"table":({"view_step":"Se step", "the_step_was_deleted":"Steppet blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;